import React from 'react';
import ReactDOM from 'react-dom/client';
import { EventType, PublicClientApplication, type AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './config/authConfig';
import { handleTeamsAuthPopup } from './auth/teamsAuthPopup';
import { App } from './App';
import './index.css';

const msalInstance = new PublicClientApplication(msalConfig);

async function bootstrap() {
  // Im Teams-Auth-Popup nur die Anmeldung abwickeln, nicht die App rendern.
  if (await handleTeamsAuthPopup(msalInstance)) {
    return;
  }

  await msalInstance.initialize();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      if (payload.account) {
        msalInstance.setActiveAccount(payload.account);
      }
    }
  });

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <App instance={msalInstance} />
    </React.StrictMode>,
  );
}

void bootstrap();
